import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 96.854 77.483',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      className="icon"
      d="M96.082,70.022,52.5,2.225a4.843,4.843,0,0,0-8.148,0L.766,70.022A4.842,4.842,0,0,0,4.84,77.483H92.008a4.843,4.843,0,0,0,4.074-7.461ZM48.424,13.8,61.346,33.9H48.424l-9.685,9.685-5.76-5.76Z"
      transform="translate(0.003)"
      fill={fill}
    />
  </svg>
);

export default SVG;
